import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 41.531 43.818"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\"><path data-name=\"Path 7875\" d=\"m30.765 42.757 4.852-4.852m4.853-4.852-4.853 4.852m0 0-4.852-4.852m4.852 4.852 4.853 4.852\"></path><path data-name=\"Path 7876\" d=\"M.75 7.612v13.725s0 6.862 16.012 6.862 16.012-6.862 16.012-6.862V7.612\"></path><path data-name=\"Path 7877\" d=\"M16.762.75c16.013 0 16.013 6.862 16.013 6.862s0 6.862-16.012 6.862S.75 7.612.75 7.612.75.75 16.762.75Z\"></path><path data-name=\"Path 7878\" d=\"M16.762 41.924C.75 41.924.75 35.062.75 35.062V21.337\"></path></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };